<template>
    <div class="card-form md">
        <h5 class="card-form-title">{{pageTitle}}</h5>

        <div class="card-form-file-group">
            <label for="image" class="card-form-label">Imagen:</label>
            <DragAndDrop />
        </div>
        <div class="card-form-group">
            <label for="title" class="card-form-label">Título:</label>
            <input @keyup="setOfferTitle" v-model="title" type="text" class="card-form-input" :class="title ?  'active' : ''" placeholder="Máximo 56 carácteres" maxlength="56">
        </div>
        <div class="card-form-group">
            <label for="title" class="card-form-label">Descripción:</label>
            <textarea name="description" placeholder="Máximo 88 carácteres" maxlength="88" @keyup="setOfferDesc" v-model="desc" :class="desc ? 'active' : ''"></textarea>
        </div>
        <div class="card-form-group">
            <label for="category" class="card-form-label">Categoría:</label>

            <!-- <div style="overflow-x: auto; display: flex; justify-content:center">
                <div class="categories">
                    <draggable tag="div" :list="categories" class="draggable-horizontal" group="categories" @update="handleUpdate">
                        <div class="draggable-item-horizontal" v-for="(item, index) in categories" :key="index">
                            <div class="category">
                                <input type="radio" :id="'input-' + (index + 1)" :value="index + 1" :checked="item.active" name="category" v-model="cat" v-on:change="setOfferCat">
                                <label :for="'input-' + (index + 1)" >
                                    <span :class="'category-' + item.id"></span>
                                    <p>{{ item.value }}</p>                                    
                                </label>  
                            </div>
                        </div>
                    </draggable>
                </div>
            </div> -->
            <div class="categories">
                <div class="category">
                    <input type="radio" id="first-category" value="1" checked="checked" name="category" v-model="cat" v-on:change="setOfferCat">
                    <label for="first-category" >
                        <span class="category-1"></span>
                        <p>{{ category_1}}</p>
                    </label>
                </div>
                <div class="category">
                    <input type="radio" id="second-category" value="2" name="category" v-model="cat" v-on:change="setOfferCat">
                    <label for="second-category" >
                        <span class="category-2"></span>
                        <p>{{ category_2 }}</p>
                    </label>
                </div>
                <div v-if="category_3" class="category">
                    <input type="radio" id="third-category" value="3" name="category" v-model="cat" v-on:change="setOfferCat">
                    <label for="third-category" >
                        <span class="category-3"></span>
                        <p>{{ category_3 }}</p>
                    </label>
                </div>  
                <div v-if="category_4" class="category">
                    <input type="radio" id="four-category" value="4" name="category" v-model="cat" v-on:change="setOfferCat">
                    <label for="four-category" >
                        <span class="category-4"></span>
                        <p>{{ category_4 }}</p>
                    </label>
                </div>
            </div>
        </div>
        <div class="card-form-group">
            <label for="category" class="card-form-label">Selecciona el público objetivo de tu contenido:</label>
            <div class="buttons">
                <button disabled v-bind:class="['btn-profile disabled', perfil_id===1 ? '' : '']" @click="perfil_id = 1">
                    <input type="radio" :checked="perfil_id === 1" disabled>
                    Clientes
                </button>
                <button disabled v-bind:class="['btn-profile disabled', perfil_id===2 ? '' : '']" @click="perfil_id = 2">
                    <input type="radio" :checked="perfil_id === 2" disabled>
                    No clientes
                </button>
                <button v-bind:class="['btn-profile', perfil_id===3 ? 'selected' : 'selected']" @click="perfil_id = 3">
                    <input type="radio" checked>
                    Todos
                </button>
            </div>
        </div>
            
        <div class="card-form-group">
            <label for="title" class="card-form-label">Texto del botón:</label>
            <input @keyup="setOfferBtn" v-model="btnText" type="text" class="card-form-input" :class="btnText ?  'active' : ''" placeholder="Máximo 16 carácteres" maxlength="16">
        </div>
        <div class="separator"></div>

        <div class="card-form-group">
            <label for="title" class="card-form-label">Tipo de interacción: </label>
            <div class="categories">
                <div class="interaction">
                    <input type="radio" id="link" value="1" checked="checked" name="interaction" v-model="action_type">
                    <label for="link" >
                        <i class="icon ico-link"></i>
                        <p>Enlace</p>
                    </label>
                </div>
                <div class="interaction">
                    <input type="radio" id="mail" value="2" name="interaction" v-model="action_type">
                    <label for="mail" >
                        <i class="icon ico-mail"></i>
                        <p>Mail</p>
                    </label>
                </div>
                <div class="interaction">
                    <input type="radio" id="call" value="3" name="interaction" v-model="action_type">
                    <label for="call" >
                        <i class="icon ico-phone"></i>
                        <p>Contacto</p>
                    </label>
                </div>  
            </div>
        </div>
        <div class="card-form-group-column" v-if="action_type==1">
            <label for="title" class="card-form-label">Dirección del enlace:</label>
            <input v-model="action" type="text" class="card-form-input" :class="okAction ? 'active' : ''" placeholder="http://www.elun.cl" maxlength="100">
            <span class="error-text">{{ textError }}</span>
        </div>
        <div class="card-form-group-column" v-else-if="action_type==2">
            <label for="title" class="card-form-label">Correo de contacto:</label>
            <input v-model="action" type="email" class="card-form-input" :class="okAction ? 'active' : ''" placeholder="contacto@elun.cl" maxlength="50">
            <span class="error-text">{{ textError }}</span>
        </div>
        <div class="card-form-group-column" v-else-if="action_type==3">
            <label for="title" class="card-form-label">Número de llamado:</label>
            <input v-model="action" type="tel" class="card-form-input" :class="okAction ? 'active' : ''" placeholder="+56944445555" maxlength="12">
            <span class="error-text">{{ textError }}</span>
        </div>
        <div class="card-form-group-dates">
            <!-- <div class="start">
                <label for="title" class="card-form-label">Fecha de inicio:</label>
                <div disabled class="card-publish-datepicker">
                    <label for="init_date"><i class="fa fa-calendar-alt"></i></label>
                    <datepicker class="datepicker"
                        :language="es"
                        :disabled-dates="disabledInitDate"
                        v-model="initDate"
                        :input-class="initDate?'card-publish-input active':'card-publish-input'"
                        id="init_date"
                        placeholder="YYYY-MM-DD"></datepicker>
                </div>
            </div> -->
            <div class="end">
                <label for="title" class="card-form-label">Fecha de término: (opcional)</label>
                <div class="card-publish-datepicker">
                    <label for="end_date"><i class="fa fa-calendar-alt"></i></label>
                    <datepicker class="datepicker"
                        :language="es"
                        :disabled-dates="disabledEndDate"
                        v-model="endDate"
                        :input-class="endDate?'card-publish-input active':'card-publish-input'"
                        id="end_date"
                        placeholder="YYYY-MM-DD"></datepicker>
                </div>
            </div>
        </div>

        <div class="buttons">
            <button class="button ghost md black umami--click--cancelar-creacion-oferta" @click="$route.name == 'new_content' ? $router.push('/contenido') : $router.push('/ofertas/gestion')">
                <p>Cancelar</p>
            </button>
            <button class="button md primary disabled umami--click--confirmar-creacion-oferta" :class="okForm ? 'active' : ''" :disabled="!okForm" @click.prevent="submitOffer()" >
                <p>{{createButton}}</p>
            </button>
        </div>
    </div>
</template>

<script>
import DragAndDrop from '@/components/DragAndDrop'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
// import draggable from 'vuedraggable'

export default {
    name: 'FormCard',
    components: {
        DragAndDrop,
        Datepicker,
        // draggable
    },
    data: function(){
        return {
            category_1: process.env.VUE_APP_CATEGORY_1,
            category_2: process.env.VUE_APP_CATEGORY_2,
            category_3: process.env.VUE_APP_CATEGORY_3,
            category_4: process.env.VUE_APP_CATEGORY_4,
            es: es,
            pageTitle: '',
            title: '',
            btnText: '',
            action_type: 1,
            action: '',
            desc: '',
            interaction: 'Enlace',
            opts: false,
            cat: 1,
            list: [
                {'label': 'Enlace', 'value': 1},
                {'label': 'Contacto', 'value': 2},
                {'label': 'Llamado', 'value': 3}
            ],
            btnOpts: false,
            initDate: new Date(),
            endDate: null,
            createButton: "Crear",
            // categories: [
            //     {id:1, value:process.env.VUE_APP_CATEGORY_1, active: true}, 
            //     {id:2, value:process.env.VUE_APP_CATEGORY_2, active: false}, 
            //     {id:3, value:process.env.VUE_APP_CATEGORY_3, active: false}
            // ],
            perfil_id: 1
        }
    },
    created: function(){
      this.$store.dispatch("auth/setActive", "content");
      if (this.$route.name == "new_content") {
        this.pageTitle = 'Diseña tu Contenido'
        // this.setEmptyDummyOffer()
      } else if (this.$route.name == "content_detail") {
        this.pageTitle = 'Edita  tu Contenido'
        this.createButton = "Guardar cambios"
        this.setSelectedOffer(this.getOffer(this.$route.params.id)[0])
      }
    },
    mounted: function(){
        this.title = this.dummyOffer.name
        this.btnText = this.dummyOffer.button_text
        this.desc = this.dummyOffer.description
        this.cat = this.dummyOffer.category[0].id
        this.action_type = this.dummyOffer.action_type
        if (this.action_type > 1) {
            this.interaction = this.list[this.action_type - 1].label
        }
        this.action = this.dummyOffer.action
        this.perfil_id = +this.dummyOffer.profile_id[0]
    },
    methods: {
        // handleUpdate(e) {
        //     // TODO: cuando cambia el orden de las categorias
        // },
        date: function(date){
            return moment(date).format('YYYY-MM-DD');
        },
        submitOffer: function(){
            var offer = {}
            var form = new FormData();
            if (typeof(this.dummyOffer.images) != 'string'){
                form.append("images", this.dummyOffer.images)
            }
            form.append("name", this.title);
            form.append("button_text", this.btnText);
            form.append("description", this.desc);
            form.append("action_type", this.action_type);
            form.append("action", this.action);
            form.append("is_active", true)
            form.append("category", [this.cat]);
            form.append("init_date", this.date(this.initDate));
            if(this.endDate!=null){
                form.append("end_date", this.date(this.endDate));
            }
            form.append("perfil_id", this.perfil_id);
            form.append("stores", this.stores.map( store => store.id ));
            
            
            if (this.dummyOffer.id){
                offer = {
                    'id': this.dummyOffer.id,
                    'form': form
                }
            } else {
                offer = {
                    'form': form
                }
            }
            
            this.$emit('submitOffer', offer)
        },
        submitOfferAndPublish: function(){
            var offer = {}
            var form = new FormData();
            if (typeof(this.dummyOffer.images) != 'string'){
                form.append("images", this.dummyOffer.images)
            }
            form.append("name", this.title);
            form.append("title", this.sub);
            form.append("description", this.desc);
            form.append("action_type", this.action_type);
            form.append("action", this.action);
            form.append("category", [this.cat]);
            offer = {
                'form': form,
                'publish': true
            }
            this.$emit('submitOffer', offer)
        },
        selectInteraction: function(value) {
            this.opts = false
            this.action_type = value
            let actionSelected = this.list.filter( data => {
                return data.value == this.action_type
            })
            this.interaction = actionSelected[0].label
        },
        setOfferTitle: function(e){
            console.log(e)
            this.setOfferHeader(this.title)
        },
        setOfferBtn: function(e){
            console.log(e)
            this.setOfferBtnText(this.btnText)
        },
        setOfferDesc: function(e){
            console.log(e)
            this.setOfferDescription(this.desc)
        },
        setOfferAct: function(e){
            this.setOfferAction(e.target.value)
        },
        setOfferCat: function(e){
            console.log(e)
            this.setOfferCategory(e.target.value)
        },
        closePublishOpt: function(){
            if (this.btnOpts){
                this.btnOpts = false;
            }
        },
        getOfferOrder: function(categoryId){
            const categoryOffers = this.offers.filter(offer => {
                return offer.category[0].id == categoryId
            })
            return categoryOffers.length <= 2 ? categoryOffers.length + 1: 3
        },
        ...mapActions('offers', [
            'setOfferHeader',
            'setOfferBtnText',
            'setOfferDescription',
            'setOfferActionType',
            'setOfferAction',
            'setSelectedOffer',
            'setOfferCategory',
        ])
    },
    computed: {
        disabledInitDate: function(){
            return {to: (d => new Date(d.setDate(d.getDate()-1)))(new Date)}
        },
        disabledEndDate: function(){
            return {to: this.initDate}
        },
        textError: function(){
            if (this.action.length > 3) {
                if(this.action_type == 1){
                    const regex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;
                    if (regex.test(this.action)) {
                        return ''
                    }
                    return 'Formato esperado: http://www.example.com'
                } else if (this.action_type == 2){
                    const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                    if (regex.test(this.action)) {
                        return ''
                    }
                    return 'Formato esperado: info@example.com'
                } else if (this.action_type == 3){
                    const regex = /^(\+?56)?(\s?)(0?9)(\s?)[0-9]\d{7}$/;
                    if (regex.test(this.action)){
                        return ''
                    }
                    return 'Formato esperado: +56944445555'
                }
            }
            return ''
        },
        okForm: function(){
            let img = this.getDummyOffer.images
            if (this.title && this.btnText && this.action_type && this.okAction && this.desc && img) {
                return true
            }
            return false
        },
        okAction: function(){
            if(this.action_type == 1){
                // eslint-disable-next-line no-useless-escape
                const regex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;
                return regex.test(this.action)
            } else if (this.action_type == 2){
                // eslint-disable-next-line no-useless-escape
                const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return regex.test(this.action)
            } else if (this.action_type == 3){
                const regex = /^(\+?56)?(\s?)(0?9)(\s?)[0-9]\d{7}$/;
                return regex.test(this.action)
            }
            return false
        },
        dummyOffer: function(){
            return this.getDummyOffer
        },
        offers: function() {
            const offers = this.getOffers
            return offers
        },
        stores: function(){
            const stores = this.getStores
            return stores
        },
        // ...mapGetters('offers', [
        //     'getDummyOffer',
        //     'getOffer',
        //     'allOffers'
        // ],'getOffers': 'offers/allOffers',)
        ...mapGetters({
            'getOffers': 'offers/allOffers',
            'getDummyOffer': 'offers/getDummyOffer',
            'getOffer': 'offers/getOffer',
            'getStores': 'stores/allStores',
        })
    },
    directives: {
        clickoutside: {
            bind: function (el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                // here I check that click was outside the el and his childrens
                if (!(el == event.target || el.contains(event.target))) {
                    // and if it did, call method provided in attribute value
                    vnode.context[binding.expression](event);
                }
                };
                document.body.addEventListener('click', el.clickOutsideEvent)
            },
            unbind: function (el) {
                document.body.removeEventListener('click', el.clickOutsideEvent)
            },
            stopProp(event) { event.stopPropagation() }
        }
    }
}
</script>

<style lang="sass">
.draggable-horizontal 
    display: flex
    flex-wrap: nowrap
    overflow-x: auto
.draggable-item-horizontal
    margin-right: 10px
.card-form
    position: relative
    grid-column-start: 2
    width: 100%
    border-radius: 4px
    border: solid 1px #e5edf4
    background-color: #ffffff
    display: flex
    flex-direction: column
    justify-content: center
    grid-gap: 16px 8px
    padding: 16px 8px
    box-sizing: border-box
    .separator
        width: 60%
        height: 1px
        background: $dark-grey
        display: flex
        margin: 16px auto
        border-radius: 24px
    .buttons
        display: flex
        width: 65%
        justify-content: center
        align-self: center
        margin-top: 40px
        @include tablet-portrait
            width: 100%
        button
            margin: 0px $sm
            @include tablet-portrait
                min-width: 160px
    .categories
        display: flex
        flex-direction: row
        width: 40%
        margin-top: 8px
        justify-content: space-between
        align-self: center
        justify-self: center
        @include tablet-portrait
            width: 60%
        .category
            height: 56px
            width: 56px
            display: flex
            align-items: center
            justify-content: center
            input[type="radio"]
                appearance: none
            
            label
                display: flex
                flex-direction: column
                align-items: center
                cursor: pointer
                span
                    width: 32px
                    height: 32px
                    display: block
                .category-1
                    background: url(../../assets/icons/categories/cat-01-in.svg) no-repeat center
                .category-2
                    background: url(../../assets/icons/categories/cat-02-in.svg) no-repeat center
                .category-3
                    background: url(../../assets/icons/categories/cat-03-in.svg) no-repeat center
                .category-4
                    background: url(../../assets/icons/categories/cat-04-in.svg) no-repeat center
                .active-cat-1
                    background: url(../../assets/icons/categories/cat-01-ac.svg) no-repeat center
                .active-cat-2
                    background: url(../../assets/icons/categories/cat-02-ac.svg) no-repeat center
                .active-cat-3
                    background: url(../../assets/icons/categories/cat-03-ac.svg) no-repeat center
                .active-cat-4
                    background: url(../../assets/icons/categories/cat-04-ac.svg) no-repeat center
                p
                    font-family: $body-font
                    font-size: 10px
                    color: $dark-grey
                    width: 100%
                    margin-top: 4px
                    text-align: center
            input[type="radio"]:checked + label
                span.category-1
                    background: url(../../assets/icons/categories/cat-01-ac.svg) no-repeat center
                span.category-2
                    background: url(../../assets/icons/categories/cat-02-ac.svg) no-repeat center
                span.category-3
                    background: url(../../assets/icons/categories/cat-03-ac.svg) no-repeat center
                span.category-4
                    background: url(../../assets/icons/categories/cat-04-ac.svg) no-repeat center
                p
                    color: $secondary-active
        .interaction
            height: 56px
            width: 56px
            display: flex
            align-items: center
            justify-content: center
            input[type="radio"]
                appearance: none
            label
                display: flex
                flex-direction: column
                align-items: center
                color: $dark-grey
                cursor: pointer
                .icon
                    font-size: 24px
                    display: block
                p
                    font-family: $body-font
                    font-size: 10px
                    width: 100%
                    margin-top: 4px
                    text-align: center
            input[type="radio"]:checked + label
                color: $secondary-active



.card-form.md
    grid-column-end: span 2
    @media (max-width: $tablet)
        grid-column-end: span 1
.card-form-file-group
    margin-bottom: 24px
    position: relative
    width: 100%
    margin-top: 24px
.card-form-group
    width: 100%
    display: flex
    flex-direction: column
    margin: $md 0
    textarea
        resize: none
        font-family: $body-font
        font-size: 16px
        color: $dark
        box-sizing: border-box
        padding: $xs
        border: none
        background: #f0f4f5
        border-left: 2px solid $dark-grey
        border-radius: 0px
        outline: none
        font-weight: 600
        &:hover,&:focus,&.active
            border-left: 2px solid $secondary
        &::placeholder
            opacity: 0.6
.card-form-group-dates
    display: flex
    flex-direction: row
    margin-top: $md
    .start
        width: 50%
    .end
        width: 100%
.card-form-group-column
    width: 100%
    .error-text
        font-family: $body-font
        font-size: 12px
        font-weight: 300
        color: #c90b2f
.card-form-label
    font-family: $body-font
    font-size: 12px
    font-weight: 300
    color: #636363
    display: block
    margin-bottom: 8px
.card-form-input
    width: calc(100% - 18px)
    border: none
    outline: none
    background: #f0f4f5
    border-left: 2px solid $dark-grey
    padding: 6px 8px
    font-family: $body-font
    font-size: 16px
    font-weight: 600
    color: $dark
    &:hover,&:focus,&.active
        border-left: 2px solid $secondary
.card-form-input.active
    border-color: $secondary
.card-form-input.disabled
    width: calc( 100% - 16px)
    border-left: none
.card-form-input::placeholder
    font-family: Muli
    font-size: 16px
    font-weight: 600
    color: $dark
    opacity: 0.4
.card-form-input.disabled::placeholder
    opacity: 0.2
.card-form-input-select
    position: relative
    display: inline-block
    width: 100%
    cursor: pointer
.custom-select
    width: 100%
    height: 32px
    padding-left: 8px
    line-height: 32px
    background: transparent
    font-family: Muli
    font-size: 14px
    font-weight: 600
    color: $dark
    margin-bottom: 0
    float: right
    cursor: pointer
    @media (max-width: $tablet)
        width: calc(100% - 8px)
.custom-select.active
    background-color: #ffffff
    border-radius: 4px
    color: #999999
.custom-select-opts
    position: absolute
    top: calc(100% + 4px)
    left: 0
    width: 100%
    background-color: #ffffff
    box-shadow: 0 0 4px 0 rgba(161,166,183,0.45)
    border-radius: 4px
    z-index: 999
.custom-select-opts p 
    font-family: Muli
    font-size: 16px
    font-weight: 500
    color: $dark
    padding: 4px
    cursor: pointer
    position: relative
    @media (max-width: $tablet)
        padding: 10px 4px
.custom-select-opts p:first-of-type
    border-top-left-radius: 4px
    border-top-right-radius: 4px
.custom-select-opts p:last-of-type
    border-bottom-left-radius: 4px
    border-bottom-right-radius: 4px
.custom-select-opts p:hover
    background-color: #0b99d8
    color: #ffffff
    @media (max-width: $tablet)
        background-color: #ffffff
        color: $dark
.custom-select-opts p:hover::after
    @media (max-width: $tablet)
        content: ""
        position: absolute
        bottom: 0
        left: 0
        width: 90%
        margin: 0 5%
        height: 1px
        background-color: rgba($secondary, 0.2)
.select-append
    position: absolute
    top: 8px
    right: 4px
.card-publish
    width: 100%
.card-publish .card
    width: 100%
    border-radius: 4px
    border: solid 1px #e5edf4
    background-color: #ffffff
    display: grid
    grid-template-columns: 8px 1fr 1fr 8px
    grid-gap: 16px 8px
.card-publish.md
    grid-column-end: span 2
.card-publish-title
    grid-column-start: 2
    margin: 16px 2px
    font-family: Montserrat
    font-size: 20px
    font-weight: 600
    color: #302f2f
.card-publish-big-group
    grid-column-start: 2
    grid-column-end: span 2
    position: relative
    width: 100%
.card-publish-group
    grid-column-start: 2
    width: 100%
.card-publish-group-column
    width: 100%
.card-publish-label
    font-family: Muli
    font-size: 12px
    font-weight: 300
    color: #636363
    display: block
    margin-bottom: 8px
.card-publish-input
    width: 100%
    border: none
    outline: none
    background: #ffffff
    padding: 6px 8px
    font-family: Muli
    font-size: 16px
    font-weight: 600
    color: #302f2f
.card-publish-input::placeholder
    font-family: Muli
    font-size: 16px
    font-weight: 600
    color: #302f2f
    opacity: 0.4
.card-publish-input.disabled::placeholder
    opacity: 0.2
.card-publish-input-select
    position: relative
    display: inline-block
    width: 100%
    cursor: pointer
.card-publish-datepicker
    position: relative
.card-publish-datepicker i.fa-calendar-alt
    position: absolute
    margin-top: 4px
    right: 4px
    color: $secondary
    font-size: 16px
    font-weight: 100
    z-index: 200
.vdp-datepicker__calendar
    right: 0
    bottom: 0
.btn-profile
    display: flex
    padding: 8px
    align-items: center
    gap: 8px
    justify-content: left
    border-radius: 8px
    border: 1px solid var(--Text-Light-gray, #BFBFBF)
    color: var(--Text-Dark-gray, #727272)
    font-family: Montserrat
    font-size: 14px
    font-style: normal
    font-weight: 600
    line-height: normal
    background: var(--States-Transparent-Default, rgba(183, 183, 183, 0.10))
    flex: 1 0 0
    cursor: pointer
.btn-profile.selected
    border: 1px solid $secondary
    color: #000000
.btn-profile.disabled
    background: var(--States-Transparent-Disabled, rgba(183, 183,
    183, 0.05))
    border: 1px solid var(--Text-Light-gray, #BFBFBF)
    color: var(--Text-Light-gray, #BFBFBF)
    cursor: not-allowed
    .btn-profile.selected:hover
    cursor: default
.btn-profile:hover
    border: 1px solid $secondary
    color: #000000
    background: var(--States-Transparent-Default, rgba(53, 138, 221, 0.4))
</style>